import { environment } from "../../environments/environment";

export class MenuHelper {

	serverUrl = environment.kotlin;

	constructor() {
	}
}
